import { Card, CardContent } from "@/components/ui/card"
import { LucideIcon, TrendingUp, TrendingDown } from "lucide-react"
import { cn } from "@/lib/utils"

interface StatCardProps {
  title: string
  value: string
  change: string
  trend?: "up" | "down" | "neutral"
  icon: LucideIcon
  color: "primary" | "secondary" | "muted"
  locked?: boolean
}

const colorClasses = {
  primary: {
    text: "text-primary",
    bg: "bg-primary/10",
  },
  secondary: {
    text: "text-secondary",
    bg: "bg-secondary/10",
  },
  muted: {
    text: "text-muted-foreground",
    bg: "bg-muted/10",
  },
}

export function StatCard({
  title,
  value,
  change,
  trend = "neutral",
  icon: Icon,
  color,
  locked = false
}: StatCardProps) {
  const colors = colorClasses[color]
  
  return (
    <Card className="bg-card border-border/50 shadow-lg rounded-2xl group hover:border-primary/30 transition-all duration-300">
      <CardContent className="p-6">
        <div className="flex items-start justify-between mb-4">
          <div className={cn("w-12 h-12 rounded-lg flex items-center justify-center border", colors.bg, colors.text.includes("primary") ? "border-primary/30" : colors.text.includes("secondary") ? "border-secondary/30" : "border-border/30")}>
            <Icon className={cn("w-6 h-6", colors.text)} />
          </div>
          {trend !== "neutral" && (
            <div className={cn(
              "flex items-center gap-1 text-xs font-medium",
              trend === "up" ? "text-primary" : "text-destructive"
            )}>
              {trend === "up" ? (
                <TrendingUp className="w-3 h-3" />
              ) : (
                <TrendingDown className="w-3 h-3" />
              )}
            </div>
          )}
        </div>
        <div className="space-y-1">
          <p className="text-sm text-muted-foreground">{title}</p>
          <p className={cn("text-2xl font-bold text-foreground group-hover:text-primary transition-colors", locked && "blur-sm select-none")}>
            {value}
          </p>
          <p className="text-xs text-muted-foreground">{change}</p>
        </div>
      </CardContent>
    </Card>
  )
}
